import { OrderDto, OrderStatus, ReceiptType } from '../../../api/ClientApi';

export const getReceiptTypeBasedOnOrder = (order?: OrderDto): ReceiptType | undefined => {
    if (!order || (!order.originSite && !order.supplier) || !order.destinationSite) {
        return undefined;
    }

    if (order.orderStatus === OrderStatus.Transport || order.orderStatus === OrderStatus.Delivered) {
        return ReceiptType.Reception;
    }

    if (
        order.orderStatus === OrderStatus.Idle ||
        order.orderStatus === OrderStatus.Pending ||
        order?.orderStatus === OrderStatus.Approved
    ) {
        if (!!order.supplier && !order.originSite && !!order.destinationSite) {
            return undefined;
        }
        if (!!order.originSite && !!order.destinationSite) {
            if (
                (!order.originSite.project?.clientId && !order.destinationSite.project?.clientId) ||
                (!!order.originSite.project?.clientId && !!order.destinationSite.project?.clientId)
            ) {
                return ReceiptType.Transfer;
            }

            if (!order.originSite.project?.clientId && !!order.destinationSite.project?.clientId) {
                return ReceiptType.Delivery;
            }

            if (!!order.originSite.project?.clientId && !order.destinationSite.project?.clientId) {
                return ReceiptType.Return;
            }
        }
    }

    return undefined;
};
